// tooltip-overlay.component.ts
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tooltip-overlay',
  templateUrl: './tooltipOverlay.component.html',
  styleUrls: ['./tooltipOverlay.component.scss'],
})
export class TooltipOverlayComponent {
  @Input() html = '';
}
